<template>
  <div class="zyc-tabs">
    <div class="zyc-tabs-header">
      <div class="zyc-tabs-header-content">
        <div v-for="(v,i) in header" :class="v.active ? 'zyc-tabs-header-but-active':'zyc-tabs-header-but'" :name="'tab-pane-'+i" @click="tabsChange(i)"><span>{{ v.value }}</span></div>
      </div>
    </div>
    <div style="clear:both;"></div>
    <slot></slot>
    <div style="clear:both;"></div>
    <div class="zyc-tabs-header">
      <div class="zyc-tabs-header-1"></div>
      <div class="zyc-tabs-header-2"><p></p></div>
      <div class="zyc-tabs-header-3"></div>
      <div class="zyc-tabs-header-4"><p></p></div>
      <div class="zyc-tabs-header-c"></div>
      <div class="zyc-tabs-header-5"><p></p></div>
      <div class="zyc-tabs-header-6"><p></p></div>

    </div>
  </div>
</template>
<script>
  /**
  * 标签页容器
  */
  export default {
    name: 'zycNewtabs',
    props: {
      tabChange: {
        type: Function,
        default: () => { }
      }
    },
    model: {
    },
    watch: {
    },
    data() {
      return {
        header: [],
        tabPanes: []
      }
    },
    mounted() {

    },
    created() {
      this.$nextTick(() => {
        this.init()
      })

    },
    methods: {
      init: function () {
        this.tabPanes = this.$slots.default.filter(vnode => vnode.tag && vnode.componentOptions && vnode.componentOptions.Ctor.options.name === 'zycTabPane')
        this.header = []
        this.tabPanes.forEach((el, i) => {
          $(el.elm).attr('id', 'tab-pane-' + i)
          if (i > 0) {
            $(el.elm).hide()
            this.header.push({
              active: false,
              value: el.elm.attributes['arialabel'].nodeValue
            })
          } else {
            $(el.elm).css('opacity', '1')
            this.header.push({
              active: true,
              value: el.elm.attributes['arialabel'].nodeValue
            })
          }
        })
      },
      clearActive: function () {
        this.header.forEach(el => {
          el.active = false
        })
        this.tabPanes.forEach(el => {
          $(el.elm).hide()
          $(el.elm).css('opacity', '0')
        })
      },
      tabsChange: function (index) {
        this.clearActive()
        this.header[index].active = true
        $($(this.tabPanes[index])[0].elm).show()
        $($(this.tabPanes[index])[0].elm).css('opacity', '1')
        this.tabChange(index)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/tabs/newtabs.vue